import { z } from "zod";
import { LookupQuerySchema } from "./common";

export const StaffStatusSchema = z.enum(["active", "inactive"]);
export type StaffStatus = z.infer<typeof StaffStatusSchema>;

export const StaffSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  defaultRoleLabel: z.string().nullable(),
  bankName: z.string().nullable(),
  bankAccount: z.string().nullable(),
  accountName: z.string().nullable(),
  phone: z.string().nullable(),
  notes: z.string().nullable(),
  performerId: z.string().nullable(),
  performerName: z.string().nullable().optional(),
  status: StaffStatusSchema,
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type StaffDTO = z.infer<typeof StaffSchema>;

export const CreateStaffSchema = z.object({
  displayName: z.string().trim().min(1, "ຕ້ອງປ້ອນຊື່"),
  defaultRoleLabel: z.string().trim().optional(),
  bankName: z.string().trim().optional(),
  bankAccount: z.string().trim().optional(),
  accountName: z.string().trim().optional(),
  phone: z.string().trim().optional(),
  notes: z.string().trim().optional(),
  performerId: z.string().nullable().optional(),
  status: StaffStatusSchema.optional(),
});
export type CreateStaffDTO = z.infer<typeof CreateStaffSchema>;

export const UpdateStaffSchema = z.object({
  displayName: z.string().trim().min(1, "ຕ້ອງປ້ອນຊື່").optional(),
  defaultRoleLabel: z.string().trim().nullable().optional(),
  bankName: z.string().trim().nullable().optional(),
  bankAccount: z.string().trim().nullable().optional(),
  accountName: z.string().trim().nullable().optional(),
  phone: z.string().trim().nullable().optional(),
  notes: z.string().trim().nullable().optional(),
  performerId: z.string().nullable().optional(),
  status: StaffStatusSchema.optional(),
});
export type UpdateStaffDTO = z.infer<typeof UpdateStaffSchema>;

export const StaffIdParamSchema = z.object({
  id: z.string().min(1),
});

export const StaffLookupQuerySchema = LookupQuerySchema;
export type StaffLookupQueryDTO = z.infer<typeof StaffLookupQuerySchema>;
